import axios from "axios";
import { setStore, getStore, removeStore } from "@/util/store";
import { Message } from 'element-ui'
import router from '@/router/index'
import store from '@/store'
import { generateAESKey, rsaEncrypt, aesEncrypt, aesDecrypt, base64ToHex } from '@/util/crypto'
import { Base64 } from "js-base64";
const request = axios.create({
  timeout: 300000,
  baseURL: process.env.VUE_APP_ROUTER_BASE,
  headers: { 'Content-Type': 'application/json' },
})

// 存储当前请求的AES密钥
const currentRequestKeys = new Map();

// 不需要加密的接口白名单
const encryptExcludeUrls = [
  '/ks/upload/v1/upload',
  '/ks/upload/v1/chunk-upload',
  '/ks/account/v1/upload',
  '/ks/upload/v1/upload',
  '/ks/material/v1/info/upload',
]

// 检查URL是否需要加密
const shouldEncrypt = (url) => {
  return !encryptExcludeUrls.some(excludeUrl => url.includes(excludeUrl))
}

/* request拦截器 */
request.interceptors.request.use(
  (config) => {  // 移除了 async，因为CryptoJS是同步的
    config.headers.Accept = 'application/json;charset=UTF-8'

    let token = getStore({ name: 'token' })
    token && (config.headers.Authorization = 'Bearer ' + token)

    console.log(config.url, config.data);

    if (config.method !== 'get' && shouldEncrypt(config.url)) {
      try {
        // 同步生成AES密钥
        const aesKey = generateAESKey();

        // 同步加密数据

        const encryptedData = aesEncrypt(config.data || '', aesKey);

        // 同步RSA加密AES密钥
        const encryptedAesKey = rsaEncrypt(aesKey);

        // 存储当前请求的AES密钥，用于解密响应
        const requestKey = `${config.url}_${Date.now()}`
        config.requestKey = requestKey
        currentRequestKeys.set(requestKey, aesKey);

        // 重组请求数据
        config.data = {
          content: encryptedData,
          rid: base64ToHex(encryptedAesKey)
        };
      } catch (error) {
        console.error('加密请求数据失败:', error);
        Message.error('请求数据加密失败');
        return Promise.reject(error);
      }
    }

    return config
  }, err => {
    Message.warning('网络状态差')
    return Promise.reject(err)
  }
)

function strictBase64Validation(str) {
  if (typeof str !== 'string') return false;

  // 检查字符集
  if (!/^[A-Za-z0-9+/]*={0,2}$/.test(str)) return false;

  // 检查长度（应该是4的倍数，或者有正确的填充）
  const len = str.length;
  if (len % 4 !== 0) return false;

  // 检查填充字符（只能出现在末尾，且最多2个=）
  if (str.includes('=') && !/={1,2}$/.test(str)) return false;

  // 尝试实际解码
  try {
    const decoded = Base64.decode(str);
    // 可以进一步检查解码后的内容是否合理
    return true;
  } catch (e) {
    return false;
  }
}


request.interceptors.response.use(
  (response) => {
    let rfhtoken = response.headers.refreshtoken
    if (rfhtoken) setStore({ name: 'token', content: rfhtoken });
    const isBase64 = response?.data?.data && strictBase64Validation(response.data.data);

    if (response.headers.get('data-encrypt')) {
      // if (isBase64) {
      const requestKey = response.config.requestKey
      if (requestKey && currentRequestKeys.has(requestKey) && response.data.code == 200) {
        try {
          const aesKey = currentRequestKeys.get(requestKey);
          currentRequestKeys.delete(requestKey);

          if (response.data && response.data.data) {
            // 同步解密数据
            const decryptedData = aesDecrypt(response.data.data, aesKey);
            response.data.data = decryptedData;

          }
        } catch (error) {
          console.error('解密响应数据失败:', error);
        }
      }
    }


    let res = {
      code: response.data.code || response.status,
      data: response.data.data || response.data,
      // msg: response.data.message || response.data,
      msg: response.data.message,

    }

    return res
  }, error => {


    let err = {
      code: error.response?.data?.code || 500,
      data: error.response?.data?.data || null,
      msg: error.response?.data?.message || error.response?.data?.error || '网络错误',
      requestId: error.response?.data?.requestId
    }
    if (router.history.current.path != '/') {
      if (err.code === 401 || err.code === 500) {
        store.commit('error401', err)
      } else {
        Message.warning(err.msg)
      }
    }

    return err
  })

export default request